export default {
  // ===== Page titles (order batch / operational batch; remaining keys shared) =====
  'pages.log.orderBatch.title': 'Order Batch Logs',
  'pages.log.orderBatch.subtitle':
    'Processing records of A-POS order uplink sync batches (ppos_sync_batch): inspect raw request data, error messages and failure details; filter by time, error presence, consumption status, etc.',
  'pages.log.operationalBatch.title': 'Operational Batch Logs',
  'pages.log.operationalBatch.subtitle':
    'Processing records of operational data uplink sync batches (ppos_operational_sync_batch): inspect raw request data, error messages and failure details; filter by time, error presence, consumption status, etc.',

  // ===== Table columns =====
  'pages.log.syncBatch.column.receiveTime': 'Received At',
  'pages.log.syncBatch.column.receiveTimeRange': 'Received At Range',
  'pages.log.syncBatch.column.batchNo': 'Batch No.',
  'pages.log.syncBatch.column.batchNo.placeholder': 'Exact match',
  'pages.log.syncBatch.column.batchNo.copy': 'Copy batch No.',
  'pages.log.syncBatch.column.batchNo.copied': 'Copied',
  'pages.log.syncBatch.column.tenant': 'Tenant',
  'pages.log.syncBatch.column.tenant.placeholder':
    'Select a tenant (searchable)',
  'pages.log.syncBatch.column.store': 'Store',
  'pages.log.syncBatch.column.store.placeholder': 'Select a store (searchable)',
  'pages.log.syncBatch.column.store.placeholderFirst': 'Select a tenant first',
  'pages.log.syncBatch.column.posId': 'Device ID',
  'pages.log.syncBatch.column.posId.copy': 'Copy device ID',
  'pages.log.syncBatch.column.posId.copied': 'Copied',
  'pages.log.syncBatch.column.counts': 'Total / Success / Fail / Uncovered',
  'pages.log.syncBatch.column.status': 'Outcome',
  'pages.log.syncBatch.column.processStatus': 'Process Status',
  'pages.log.syncBatch.column.consumed': 'Consumed',
  'pages.log.syncBatch.column.hasError': 'Has Error',
  'pages.log.syncBatch.column.errorMsg': 'Error Message',
  'pages.log.syncBatch.column.retryCount': 'Retries',
  'pages.log.syncBatch.column.action': 'Actions',

  // ===== Payload mode (2026-10-15 whole-order upload batch, additive; order batches only) =====
  'pages.log.syncBatch.column.payloadMode': 'Payload Mode',
  'pages.log.syncBatch.payloadMode.wholeOrder': 'Whole Order',
  'pages.log.syncBatch.payloadMode.incremental': 'Incremental',

  // ===== Enum labels =====
  'pages.log.syncBatch.processStatus.pending': 'Pending',
  'pages.log.syncBatch.processStatus.processing': 'Processing',
  'pages.log.syncBatch.processStatus.done': 'Done',
  'pages.log.syncBatch.processStatus.failed': 'Failed',
  'pages.log.syncBatch.consumed.yes': 'Consumed',
  'pages.log.syncBatch.consumed.no': 'Not Consumed',
  'pages.log.syncBatch.hasError.yes': 'Error',
  'pages.log.syncBatch.hasError.no': 'No Error',

  // ===== Common placeholders / hints =====
  'pages.log.syncBatch.placeholder.select': 'Select an option',
  'pages.log.syncBatch.tooltip.counts':
    'Total records / succeeded / failed / uncovered (not counted by the server as success or failure; includes records rejected for missing linked IDs)',
  'pages.log.syncBatch.tooltip.nameNotBackfilled': 'name not backfilled',
  // Fallback note when device-name mapping misses (DISPLAY-F7, declared diagnostic exception)
  'pages.log.syncBatch.tooltip.posNameMiss':
    'Device name not found (device not registered or deleted); falling back to device ID',
  // Fourth count tag "Uncovered N" (= total - success - fail, DISPLAY-F1)
  'pages.log.syncBatch.counts.uncovered': 'Uncovered',
  // Outcome × process-status legend (DISPLAY-F2: HTTP accepted ≠ final state)
  'pages.log.syncBatch.tooltip.statusLegend':
    'HTTP accepted ≠ final state: a successful receive only means the payload was accepted; "Process Status" is the Phase2 async progress, and the final result is determined by "Outcome" — the two may differ in time',

  // ===== Actions & messages =====
  'pages.log.syncBatch.action.detail': 'Detail',
  // Disposition loop (DISPLAY-F6): jump to the upload-payloads page with batchNo prefilled
  'pages.log.syncBatch.action.goReload': 'Go Reload',
  'pages.log.syncBatch.action.goReload.tip':
    'Jump to the Upload Payloads page with this batch No. prefilled to reload the batch',
  'pages.log.syncBatch.msg.loadDetailFailed': 'Failed to load detail',
  'pages.log.syncBatch.msg.downloadFailed': 'Download failed',

  // ===== Detail drawer =====
  'pages.log.syncBatch.drawer.title': 'Batch Detail',
  'pages.log.syncBatch.drawer.loading': 'Loading…',
  'pages.log.syncBatch.drawer.downloadRawRequest': 'Download Raw Request',
  'pages.log.syncBatch.detail.processStartTime': 'Process Start At',
  'pages.log.syncBatch.detail.processEndTime': 'Process End At',
  'pages.log.syncBatch.detail.nextRetryTime': 'Next Retry At',
  'pages.log.syncBatch.detail.processProgress': 'Progress',
  'pages.log.syncBatch.detail.rawRequestSize': 'Raw Request Size',
  'pages.log.syncBatch.detail.updateTime': 'Updated At',
  'pages.log.syncBatch.detail.errorMsg': 'Error Message',
  // Combined outcome + process-status item (DISPLAY-F2)
  'pages.log.syncBatch.detail.statusCombined': 'Outcome / Process Status',
  'pages.log.syncBatch.detail.failDetail': 'Failure Details',
  // Failure-stage note: details are produced in the Phase2 server-side persistence stage (DISPLAY-F3)
  'pages.log.syncBatch.detail.failDetailHint':
    'Failures occurred in the server-side async persistence stage (Phase2); HTTP accepted does not mean a final state',
  'pages.log.syncBatch.detail.tableStats': 'Table Stats',
  'pages.log.syncBatch.detail.rawRequest': 'Raw Request Data',
  'pages.log.syncBatch.detail.truncatedTag': 'Truncated',
  'pages.log.syncBatch.detail.copyOriginal': 'Copy full raw request',
  'pages.log.syncBatch.detail.copyTruncated':
    'Copy preview (download for full text)',
  'pages.log.syncBatch.detail.copied': 'Copied',
  'pages.log.syncBatch.detail.noPreview': 'No raw request data',

  // ===== Failure-details table (DISPLAY-F3) =====
  'pages.log.syncBatch.failDetail.dataType': 'Data Type',
  'pages.log.syncBatch.failDetail.businessNo': 'Business No.',
  // Declared diagnostic exception: POS local record ID for cross-checking client logs
  'pages.log.syncBatch.failDetail.recordId': 'POS Local Record ID',
  'pages.log.syncBatch.failDetail.recordId.tip':
    'POS local record ID (diagnostic use): the client-side row primary key, used to cross-check device logs; not a user-facing business number',
  'pages.log.syncBatch.failDetail.errorMsg': 'Failure Reason',

  // ===== failDetail.dataType dual mapping (13 English constants + legacy numeric code '13') =====
  'pages.log.syncBatch.dataType.SALES_ORDER': 'Sales Order',
  'pages.log.syncBatch.dataType.SALES_ORDER_ITEM': 'Sales Order Item',
  'pages.log.syncBatch.dataType.SALES_ORDER_PAYMENT': 'Sales Order Payment',
  'pages.log.syncBatch.dataType.SALES_ORDER_DISCOUNT':
    'Sales Order Discount Allocation',
  'pages.log.syncBatch.dataType.SALES_ORDER_GOV_PERSON':
    'Sales Order Gov Person',
  'pages.log.syncBatch.dataType.SALES_ORDER_GOV_PERSON_ITEM_REL':
    'Gov Person-Item Relation',
  'pages.log.syncBatch.dataType.SALES_ORDER_PAYMENT_ALLOCATION':
    'Sales Order Payment Allocation',
  'pages.log.syncBatch.dataType.SALES_ORDER_REFUND': 'Sales Order Refund',
  'pages.log.syncBatch.dataType.SALES_ORDER_REFUND_ITEM': 'Refund Item',
  'pages.log.syncBatch.dataType.REFUND_GOV_PERSON_ITEM_REL':
    'Refund Gov Person-Item Relation',
  'pages.log.syncBatch.dataType.SALES_ORDER_VOID': 'Sales Order Void',
  'pages.log.syncBatch.dataType.DINING_ORDER': 'Dining Order',
  'pages.log.syncBatch.dataType.DINING_ORDER_ITEM': 'Dining Order Item',
  // Legacy numeric code (historical rows, e2e fixture form)
  'pages.log.syncBatch.dataType.13': 'Sales Item',

  // ===== Upload-payloads detail drawer · batch processing outcome (CLOUD-F3) =====
  'pages.log.syncBatch.detail.outcomeTitle': 'Batch Processing Outcome',
  // No processing row for this batch No. in the sync batch tables
  // (e.g. the payload was rejected at the ingestion layer)
  'pages.log.syncBatch.detail.outcomeMissing':
    'No processing row found for this batch No. in sync batch logs',
  'pages.log.syncBatch.detail.outcomeError':
    'Failed to query the batch processing outcome',
  // Count-triple labels (same semantics as the batch log count column)
  'pages.log.syncBatch.counts.total': 'Total',
  'pages.log.syncBatch.counts.success': 'Success',
  'pages.log.syncBatch.counts.fail': 'Failed',
};
